import styled from 'styled-components';
import { useState } from 'react';

const Card = ({
    _id,
    shadowBox,
    category,
    color,
    index
}) => {
    const [isCopied, setIsCopied] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    
    const handleClick = () => {
        navigator.clipboard.writeText(shadowBox);
        setIsCopied(true);
        setTimeout(() => {
            setIsCopied(false);
        }, 1500);
    };
    
    const handleMouseEnter = () => {
        setIsHovered(true);
    };
    
    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const Label = styled.div`
  position: absolute;
  bottom: 8px;
  left: 8px;
  right: 8px;
  display: flex;
  justify-content: space-between;
  font-size: 10px;
`;

const Tag = styled.span`
  background: #f1f1f1;
  padding: 3px 6px;
  border-radius: 4px;
  color: #333;
`;

const ColorDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${props => props.color};
  display: inline-block;
  margin-right: 4px;
`;

    const Box = styled.div`
        width: 200px;
        height: 200px;
        margin: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        border: solid 0.1em #ccc;
        background-color: #FFFFFF;
        position: relative;
        cursor: pointer;
        box-shadow: ${props => props.shadowBox};
        transition: all 0.3s ease;
        
        &:hover {
          transform: scale(1.07);
          box-shadow: ${props => props.shadowBox}, 0 10px 30px rgba(0,0,0,0.2);
        }
    `;
    
    const Tooltip = styled.span`
        position: absolute;
        top: -28px;
        background-color: #0c0c0c;
        color: #FFFFFF;
        padding: 5px 10px;
        border-radius: 4px;
        font-size: 12px;
        white-space: nowrap;
        z-index: 10;
    `;
    
    const SpanCopy = styled.span`
        position: absolute;
        top: 0;
        left: 0;
        margin: 10px 15px;
        opacity: ${props => props.isCopied ? 1 : 0};
        transition: opacity 0.5s ease;
        background-color: #4CAF50;
        color: white;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 12px;
    `;
    
    const IndexNumber = styled.span`
        font-size: 18px;
        font-weight: bold;
        color: #333;
    `;

    
    
    return (
        <Box 
            shadowBox={shadowBox}
            onClick={handleClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            
            {isHovered && <Tooltip>just click on box</Tooltip>}
            <IndexNumber>{index + 1}</IndexNumber>
            <SpanCopy isCopied={isCopied}>
              {isCopied ? "Copied ✅" : ""}
            </SpanCopy>
            <Label>
              <Tag>{category}</Tag>
              <Tag>
                <ColorDot color={color} /> {color}
              </Tag>
            </Label>
        </Box>
    );
};

export default Card;